// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"0db10811","460":"c0693de7","899":"bd07cc7c"}[chunkId] + ".chunk.css";
};